module.exports = __webpack_public_path__ + "static/media/DR2.ca4b6ad8.jpg";